export var toBase64 = function(blob) {
    var base64 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return new Promise(function(resolve) {
        var reader = new window.FileReader();
        reader.addEventListener("loadend", function(e) {
            var ref;
            var text = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.result;
            if (base64) {
                var ref1;
                resolve(text === null || text === void 0 ? void 0 : (ref1 = text.split) === null || ref1 === void 0 ? void 0 : ref1.call(text, ",")[1]);
            } else {
                resolve(text);
            }
        });
        if (base64) {
            reader.readAsDataURL(blob);
        } else {
            reader.readAsText(blob);
        }
    });
};
